import func from '../libs/functions';
import _ from 'lodash';

import session from './session'
import tags from './tags'

const workspaces = {
	namespaced: true,
	state: {
		currentWorkspace: {},
		currentWorkspaceSettings: {
			hiddenPlatforms: [],
			whiteLabel: false,
			loaded: false
		},
		workspaces: [],
		workspacesById: {},
		invitedWorkspaces: [],
		workspacesByUser: []
	},
	getters: {
		workspaces(state){
			return state.workspaces
		},
		currentWorkspace(state){
			return state.currentWorkspace
		},
		currentWorkspaceSettings(state){
			return state.currentWorkspaceSettings
		},
		workspacesById(state){
			return state.workspacesById
		},
		invitedWorkspaces(state){
			return state.invitedWorkspaces
		},
		workspacesByUser(state){
			return state.workspacesByUser
		}
	},
	mutations: {
		setCurrentWorkspaceSettings(state, settings){
			state.currentWorkspaceSettings = {...state.currentWorkspaceSettings, ...settings}
		},
		setWorkspaces(state, workspaces){

/* 			var userEmail = (localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).email : 'zandefined'
			
			if(localStorage.getItem('currentWorkspace'+ userEmail) ){
				if(_.find(workspaces, {_id: JSON.parse(localStorage.getItem('currentWorkspace'+ userEmail))._id })){
					state.currentWorkspace = _.find(workspaces, {_id: JSON.parse(localStorage.getItem('currentWorkspace'+ userEmail))._id })
				}else{
					state.currentWorkspace = workspaces[workspaces.length-1]
				}
			}else{
				
				state.currentWorkspace = workspaces[workspaces.length-1]
			} */

			state.workspaces = workspaces
			state.workspacesById = func.arrayToObject(workspaces, '_id')
		},
		setInvitedWorkspaces(state, workspaceUsers){
			state.invitedWorkspaces = _.filter(workspaceUsers, (workspaceUser) => workspaceUser.tags.indexOf(tags.state.tagsByName['Invited']._id) != -1 )
			state.workspacesByUser = workspaceUsers;
		},
		pushWorkspace(state, workspace){
			state.workspaces.push(workspace);	
			state.currentWorkspace = workspace
			state.workspacesById = func.arrayToObject(state.workspaces, '_id')
		},
		setCurrentWorkspace(state, workspace){
			state.currentWorkspace = workspace
		}
	},
	actions: {
		setWorkspaces({ commit }, workspaces){
			commit('setWorkspaces', workspaces)
		},
		setInvitedWorkspaces({ commit }, workspaceUsers){
			commit('setInvitedWorkspaces', workspaceUsers)
		},
		pushWorkspace({ commit }, workspace){
				commit('pushWorkspace', workspace)
		},
		setCurrentWorkspace({ commit }, workspace){
			var userEmail = (localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).email : 'zandefined'
			localStorage.setItem('currentWorkspace'+ userEmail, JSON.stringify(workspace));
				commit('setCurrentWorkspace', workspace)
		},
		setCurrentWorkspaceSettings({ commit }, settings){
			commit('setCurrentWorkspaceSettings', settings)
		}
}
}

export default workspaces;


// WEBPACK FOOTER //
// ./src/store/workspaces.js